export default __webpack_public_path__ + "static/lgbtq-pr-sj-5-48dfdf9a9d2d0dd991574cf28798fad1.jpg";